import React, { useMemo } from 'react';
import { Box, Typography, Chip, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { generateBusinessTags } from '../../utils/businessTagGenerator';

const SectionContainer = styled(Box)(({ theme }) => ({
  padding: '60px 0',
  backgroundColor: '#f8fafc'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '32px',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '40px',
  color: '#1e293b'
}));

const TagsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '12px',
  maxWidth: '1000px',
  margin: '0 auto'
}));

const TagChip = styled(Chip)(({ tagtype }) => {
  const colors = {
    location: { bg: '#dbeafe', color: '#1e40af', border: '#93c5fd' },
    proximity: { bg: '#fce7f3', color: '#9d174d', border: '#f9a8d4' },
    service: { bg: '#d1fae5', color: '#065f46', border: '#6ee7b7' },
    product: { bg: '#fef3c7', color: '#92400e', border: '#fcd34d' },
    business_type: { bg: '#e0e7ff', color: '#3730a3', border: '#a5b4fc' },
    general: { bg: '#f1f5f9', color: '#475569', border: '#cbd5e1' }
  };
  const style = colors[tagtype] || colors.general;
  return {
    backgroundColor: style.bg,
    color: style.color,
    border: `1px solid ${style.border}`,
    fontSize: '14px',
    fontWeight: 500,
    padding: '4px 8px',
    height: 'auto',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
    },
    '& .MuiChip-label': {
      padding: '6px 12px'
    }
  };
});

const TagsSection = ({
  businessInfo,
  services = [],
  products = [],
  categories = [],
  contactInfo = {},
  title = "Popular Searches"
}) => {
  const tags = useMemo(() => {
    // Use GMB categories from businessInfo or props - ONLY GMB profile categories
    const gmbCategories = businessInfo?.categories || categories || [];
    
    // If no GMB categories, don't generate tags
    if (!gmbCategories || gmbCategories.length === 0) {
      return [];
    }

    const input = {
      description: '', // Don't use description for tag generation
      services: [], // Don't use services - only GMB categories
      products: [], // Don't use products - only GMB categories
      categories: gmbCategories, // Use ONLY GMB profile categories
      locality: contactInfo?.locality || contactInfo?.area || '',
      city: contactInfo?.city || '',
      state: contactInfo?.state || ''
    };

    const result = generateBusinessTags(input);
    return result.tags;
  }, [businessInfo, categories, contactInfo]);

  if (!tags || tags.length === 0) {
    return null;
  }

  const handleTagClick = (tag) => {
    console.log('Tag clicked:', tag);
  };

  return (
    <SectionContainer>
      <Container maxWidth="lg">
        <SectionTitle variant="h2">
          {title}
        </SectionTitle>
        <TagsContainer>
          {tags.map((tag) => (
            <TagChip
              key={tag.id}
              label={tag.text}
              tagtype={tag.type}
              onClick={() => handleTagClick(tag)}
              clickable
            />
          ))}
        </TagsContainer>
      </Container>
    </SectionContainer>
  );
};

export default TagsSection;
